import { ObservationBundleCategory } from "src/types/observationLaboratory";
import type { TranslationKey } from "src/types/translationKey";

const CATEGORY_LABEL_KEY_MAP: Record<
  ObservationBundleCategory,
  TranslationKey | null
> = {
  [ObservationBundleCategory.AT_HOME]: "labResults.bundle.atHomeLab",
  [ObservationBundleCategory.SELF_TESTING]: "labResults.bundle.selfTestingLab",
  [ObservationBundleCategory.REGULAR]: "labResults.bundle.regularLab",
  [ObservationBundleCategory.IMPORTED]: "labResults.bundle.importedLab",
  [ObservationBundleCategory.SELF_REPORTED]:
    "labResults.bundle.selfReportedLab",
  [ObservationBundleCategory.UNKNOWN]: "labResults.bundle.fallback",
  [ObservationBundleCategory.EXCLUDED]: null
};

/** Maps a resolved bundle category to its translation key. EXCLUDED bundles render nothing. */
export function resolveObservationBundleLabelKey(
  category: ObservationBundleCategory
): TranslationKey | null {
  return CATEGORY_LABEL_KEY_MAP[category];
}
